import {
    TicketRedemptionCodeCategory,
    type TicketRedemptionCodeType,
    TicketVoucherTypePin,
} from '@vista-digital/occ-domain'
import { Services } from '../../../../services'

export const getTicketRedemptionCodeTypes = (): TicketRedemptionCodeType[] => {
    const cmsConfig = Services.CmsDataService.get().ticketRedemptionCodes

    if (!Array.isArray(cmsConfig) || !cmsConfig?.length) {
        // OCCs require at least one ticket redemption code.
        // We will return this default voucher to prevent the site from breaking in the even the CMS config is missing.
        return [
            {
                id: '1',
                category: TicketRedemptionCodeCategory.Voucher,
                label: 'Voucher',
                iconName: 'voucher',
                pin: TicketVoucherTypePin.None,
                codeFormat: undefined,
            },
        ]
    }

    return cmsConfig.map<TicketRedemptionCodeType>((t, index) => {
        const baseProps = {
            id: `${index + 1}`,
            label: t.label,
            iconName: 'voucher', // This icon isn't used, so can be the same for all types.
        }

        if (!t.memberTicketProviderId) {
            return {
                ...baseProps,
                category: TicketRedemptionCodeCategory.Voucher,
                pin: TicketVoucherTypePin.None,
                codeFormat: undefined,
            }
        }

        return {
            ...baseProps,
            category: TicketRedemptionCodeCategory.ThirdPartyMemberCard,
            thirdPartyMemberSchemeId: t.memberTicketProviderId,
            codeFormat: {
                partialFormat: t.providerCodePartialFormat ?? '',
                fullFormat: t.providerCodeFullFormat ?? '',
                prefixLength: t.providerCodePrefixLength ?? 0,
            },
        }
    })
}
